import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdminLayout } from "./AdminLayout";
import { Button } from "@/project/karuna/components/ui/button"; // @ts-ignore - button is not a valid module
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/project/karuna/components/ui/card"; // @ts-ignore - card is not a valid module
import { Badge } from "@/project/karuna/components/ui/badge"; // @ts-ignore - badge is not a valid module
import { Input } from "@/project/karuna/components/ui/input"; // @ts-ignore - input is not a valid module
import { Label } from "@/project/karuna/components/ui/label"; // @ts-ignore - label is not a valid module
import { Textarea } from "@/project/karuna/components/ui/textarea"; // @ts-ignore - textarea is not a valid module
import { Progress } from "@/project/karuna/components/ui/progress"; // @ts-ignore - progress is not a valid module
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/project/karuna/components/ui/alert-dialog"; // @ts-ignore - alert-dialog is not a valid module
import { useKarunaLink } from "@/project/karuna/utils/navigationRoutes";
import {
  ArrowLeft,
  Calendar,
  School,
  User,
  FileText,
  Loader2,
  Download,
  Image as ImageIcon,
  Trophy,
  History,
  CheckCircle,
  XCircle,
} from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/project/karuna/components/ui/tabs"; // @ts-ignore - tabs is not a valid module
import { useToast } from "@/project/karuna/hooks/use-toast"; // @ts-ignore - use-toast is not a valid module
import { DynamicModuleService, UploadService } from "@/services/APIs";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { removeMetaFields } from "@/lib/removeMetaFields";
import {
  mapWithConcurrency,
  DEFAULT_API_FETCH_CONCURRENCY,
} from "@/project/karuna/utils/mapWithConcurrency";

const SUBMISSION_SCHEMA_NAME = "Activity Submission";
const SCHOOL_PROFILE_SCHEMA_NAME = "School Profile";
const ACTIVITY_SCHEMA_NAME = "Activity Management";

// Schema JSON reference removed - not used in code, managed by backend

/* const SUBMISSION_SCHEMA_JSON = {
  form: {
    labelCol: 6,
    wrapperCol: 12,
    layout: "vertical",
  },
  schema: {
    type: "object",
    properties: {
      layoutContainer: {
        type: "void",
        "x-component": "FormLayout",
        "x-component-props": {
          maxColumns: 3,
          minColumns: 2,
          columnGap: 20,
          "is-in-grid": true,
        },
        name: "layoutContainer",
        "x-designable-id": "2v958xlxtkv",
        "x-index": 0,
        properties: {
          basicInfo: {
            type: "void",
            "x-component": "Card",
            "x-index": 0,
            "x-component-props": {
              title: "Section A: Basic School & Contact Details",
            },
            name: "basicInfo",
            "x-designable-id": "qrcwtrnyo9d",
            properties: {
              kcno: {
                type: "string",
                title: "KC No",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  "is-in-grid": true,
                  gridSpan: 1,
                  placeholder: "Enter KC Number",
                },
                "x-decorator-props": {},
                name: "kcno",
                "x-designable-id": "0pf7g9jtdoq",
                "x-index": 0,
                "x-validator": [],
              },
              schoolname: {
                type: "string",
                title: "School Name",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  "is-in-grid": true,
                  gridSpan: 1,
                  placeholder: "Enter school name",
                },
                "x-decorator-props": {},
                name: "schoolname",
                "x-designable-id": "sij5ro4kg2y",
                "x-index": 1,
                "x-validator": [],
              },
              nearestkendra: {
                type: "string",
                title: "Nearest Karuna Kendra Name",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Enter kendra name",
                },
                "x-decorator-props": {},
                name: "nearestkendra",
                "x-designable-id": "swbxsiq6qf5",
                "x-index": 2,
                "x-validator": [],
              },
              principalname: {
                type: "string",
                title: "School Principal's Name",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  "is-in-grid": true,
                  gridSpan: 1,
                  placeholder: "Enter principal name",
                },
                "x-decorator-props": {},
                name: "principalname",
                "x-designable-id": "9rttii384kw",
                "x-index": 3,
                "x-validator": [],
              },
              schoolcontact: {
                type: "string",
                title: "School Contact Number",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Enter contact number",
                },
                "x-decorator-props": {},
                name: "schoolcontact",
                "x-designable-id": "uw8hsv33fn9",
                "x-index": 4,
                "x-validator": [],
              },
              schoolemail: {
                type: "string",
                title: "School Email ID",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "school@example.com",
                },
                "x-decorator-props": {},
                name: "schoolemail",
                "x-designable-id": "1e9e1ua4k5o",
                "x-index": 5,
                "x-validator": [],
              },
            },
          },
          teacherInfo: {
            type: "void",
            "x-component": "Card",
            "x-index": 1,
            "x-component-props": {
              title: "Section B: Karuna Club Teacher In-Charge",
            },
            name: "teacherInfo",
            "x-designable-id": "teacherinfo001",
            properties: {
              teachername: {
                type: "string",
                title: "Name",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  "is-in-grid": true,
                  gridSpan: 1,
                  placeholder: "Enter teacher name",
                },
                "x-decorator-props": {},
                name: "teachername",
                "x-designable-id": "teachername001",
                "x-index": 0,
                "x-validator": [],
              },
              teachermobile: {
                type: "string",
                title: "Mobile Number",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Enter mobile number",
                },
                "x-decorator-props": {},
                name: "teachermobile",
                "x-designable-id": "teachermobile001",
                "x-index": 1,
                "x-validator": [],
              },
              teacheremail: {
                type: "string",
                title: "Email ID",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 2,
                  placeholder: "teacher@example.com",
                },
                "x-decorator-props": {},
                name: "teacheremail",
                "x-designable-id": "teacheremail001",
                "x-index": 2,
                "x-validator": [],
              },
            },
          },
          eventDetails: {
            type: "void",
            "x-component": "Card",
            "x-index": 2,
            "x-component-props": {
              title: "Section C: Event Program Details",
            },
            name: "eventDetails",
            "x-designable-id": "eventdetails001",
            properties: {
              state: {
                type: "string",
                title: "Select State",
                "x-decorator": "FormItem",
                "x-component": "Select",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Select state",
                },
                "x-decorator-props": {},
                name: "state",
                "x-designable-id": "state001",
                "x-index": 0,
                enum: [
                  {
                    label: "Andhra Pradesh",
                    value: "andhra",
                  },
                  {
                    label: "Karnataka",
                    value: "karnataka",
                  },
                  {
                    label: "Kerala",
                    value: "kerala",
                  },
                  {
                    label: "Tamil Nadu",
                    value: "tamilnadu",
                  },
                  {
                    label: "Telangana",
                    value: "telangana",
                  },
                ],
                "x-validator": [],
              },
              program: {
                type: "string",
                title: "Select Program",
                "x-decorator": "FormItem",
                "x-component": "Select",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Select program type",
                },
                "x-decorator-props": {},
                name: "program",
                "x-designable-id": "program001",
                "x-index": 1,
                enum: [
                  {
                    label: "Organising Intra School Programmes",
                    value: "intraschool",
                  },
                  {
                    label: "Organising Inter School Programmes",
                    value: "interschool",
                  },
                  {
                    label:
                      "Participation in Inter-School Competitions/Programmes",
                    value: "participationinter",
                  },
                  {
                    label: "Public Relation Programmes",
                    value: "publicrelation",
                  },
                  {
                    label: "Karuna Club – Internal / External Growth",
                    value: "karunaclub",
                  },
                  {
                    label:
                      "Organising / Participation in National Level Programme",
                    value: "nationallevel",
                  },
                ],
                "x-validator": [],
              },
              description: {
                type: "string",
                title: "Short Description (Max 250 words)",
                "x-decorator": "FormItem",
                "x-component": "TextArea",
                "x-component-props": {
                  gridSpan: 2,
                  placeholder: "Provide a detailed description of the event...",
                  rows: 6,
                  showCount: true,
                  maxLength: 250,
                },
                "x-decorator-props": {},
                name: "description",
                "x-designable-id": "description001",
                "x-index": 2,
                "x-validator": [],
              },
              descriptiondocument: {
                type: "Array<object>",
                title: "OR Upload Description Document (Word/PDF, Max 10MB)",
                "x-decorator": "FormItem",
                "x-component": "CustomFileUpload",
                "x-component-props": {
                  textContent: "Upload",
                },
                "x-decorator-props": {},
                name: "descriptiondocument",
                "x-designable-id": "descriptiondoc001",
                "x-index": 3,
                "x-validator": [],
              },
            },
          },
          mediaUploads: {
            type: "void",
            "x-component": "Card",
            "x-index": 3,
            "x-component-props": {
              title: "Section D: Media Uploads",
            },
            name: "mediaUploads",
            "x-designable-id": "mediauploads001",
            properties: {
              photos: {
                type: "Array<object>",
                title: "Photos of Program (4-5 photos required)",
                "x-decorator": "FormItem",
                "x-component": "CustomImageUpload",
                "x-component-props": {
                  textContent: "CustomImageUpload",
                },
                "x-validator": [],
                "x-decorator-props": {
                  layout: "vertical",
                  labelAlign: "left",
                },
                "x-designable-id": "pe35klzszon",
                "x-index": 0,
                name: "photos",
              },
            },
          },
          printMedia: {
            type: "void",
            "x-component": "Card",
            "x-index": 4,
            "x-component-props": {
              title: "Section E: Publication Details – Print Media (Optional)",
            },
            name: "printMedia",
            "x-designable-id": "printmedia001",
            properties: {
              publicationdate: {
                type: "string",
                title: "Date of Publication",
                "x-decorator": "FormItem",
                "x-component": "DatePicker",
                "x-component-props": {},
                "x-decorator-props": {},
                name: "publicationdate",
                "x-designable-id": "printpubdate001",
                "x-index": 0,
                "x-validator": [],
              },
              websiteurl: {
                type: "string",
                title: "Website URL Link",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "https://",
                },
                "x-decorator-props": {},
                name: "websiteurl",
                "x-designable-id": "printwebsiteurl001",
                "x-index": 1,
                "x-validator": [],
              },
              printscancopy: {
                type: "Array<object>",
                title: "Scan Copy of Publication (PDF/Image)",
                "x-decorator": "FormItem",
                "x-component": "CustomFileUpload",
                "x-component-props": {
                  textContent: "Upload",
                },
                "x-decorator-props": {},
                name: "printscancopy",
                "x-designable-id": "printscancopy001",
                "x-index": 2,
                "x-validator": [],
              },
            },
          },
          tvChannel: {
            type: "void",
            "x-component": "Card",
            "x-index": 5,
            "x-component-props": {
              title: "Section F: Publication Details - TV Channel (Optional)",
            },
            name: "tvChannel",
            "x-designable-id": "tvchannel001",
            properties: {
              tvchannelname: {
                type: "string",
                title: "TV Channel Name",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 1,
                  placeholder: "Enter channel name",
                },
                "x-decorator-props": {},
                name: "tvchannelname",
                "x-designable-id": "tvchannelname001",
                "x-index": 0,
                "x-validator": [],
              },
              tvtelecastdate: {
                type: "string",
                title: "Program Telecast Date",
                "x-decorator": "FormItem",
                "x-component": "DatePicker",
                "x-component-props": {},
                "x-decorator-props": {},
                name: "tvtelecastdate",
                "x-designable-id": "tvtelecastdate001",
                "x-index": 1,
                "x-validator": [],
              },
              tvprogramurl: {
                type: "string",
                title: "Program URL",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-component-props": {
                  gridSpan: 2,
                  placeholder: "https://",
                },
                "x-decorator-props": {},
                name: "tvprogramurl",
                "x-designable-id": "tvprogramurl001",
                "x-index": 2,
                "x-validator": [],
              },
              status: {
                type: "string",
                title: "Status",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-validator": [],
                "x-component-props": {
                  "is-in-grid": true,
                },
                "x-decorator-props": {},
                name: "status",
                "x-designable-id": "von4n2khmzb",
                "x-index": 3,
              },
              score: {
                type: "string",
                title: "Score",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-validator": [],
                "x-component-props": {
                  "is-in-grid": true,
                },
                "x-decorator-props": {},
                name: "score",
                "x-designable-id": "lho4eiwkz0j",
                "x-index": 4,
              },
              comments: {
                type: "string",
                title: "Comments",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-validator": [],
                "x-component-props": {
                  "is-in-grid": true,
                },
                "x-decorator-props": {},
                name: "comments",
                "x-designable-id": "qfvt7md7cve",
                "x-index": 5,
              },
              activitytitle: {
                type: "string",
                title: "Activity Title",
                "x-decorator": "FormItem",
                "x-component": "Input",
                "x-validator": [],
                "x-component-props": {},
                "x-decorator-props": {},
                name: "activitytitle",
                "x-designable-id": "ouu8sue6glf",
                "x-index": 6,
              },
            },
          },
        },
      },
    },
    "x-designable-id": "m9qhhfswuz9",
  },
}; */

// Normalize mobile number helper
const normalizeMobileNumber = (mobileNumber: string): string => {
  return String(mobileNumber ?? "")
    .replace(/\D/g, "")
    .slice(0, 10);
};

// Format date helper
const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return "N/A";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return dateString;
  } // Return original if invalid

  // Format as DD-MM-YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Format date and time with proper timezone handling - matches system time exactly
const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return "N/A";
  }
  try {
    let date: Date;

    // Handle different date string formats
    if (typeof dateString === "string") {
      // If the string doesn't have timezone info (no Z, no +/-, no timezone offset),
      // assume it's UTC and append 'Z' to make it explicit
      // This is common for backend APIs that return dates without timezone info
      let normalizedDateString = dateString.trim();

      // Check if it already has timezone info
      const hasTimezone =
        normalizedDateString.endsWith("Z") ||
        normalizedDateString.includes("+") ||
        (normalizedDateString.includes(
          "-",
          normalizedDateString.indexOf("T") + 1
        ) &&
          normalizedDateString.match(/[+-]\d{2}:?\d{2}$/));

      // If no timezone info and it looks like an ISO date/time string, assume UTC
      if (!hasTimezone && normalizedDateString.includes("T")) {
        // It's an ISO format without timezone - assume UTC
        normalizedDateString = normalizedDateString.endsWith("Z")
          ? normalizedDateString
          : normalizedDateString + "Z";
      } else if (
        !hasTimezone &&
        normalizedDateString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/)
      ) {
        // Format like "2025-12-16 06:02:18" - assume UTC and convert to ISO format
        normalizedDateString = normalizedDateString.replace(" ", "T") + "Z";
      }

      date = new Date(normalizedDateString);
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      console.warn("Invalid date string:", dateString);
      return "N/A";
    }

    // Format as DD-MM-YYYY, HH:MM:SS AM/PM
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Format time
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year}, ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  } catch (error) {
    console.warn("Error formatting date:", dateString, error);
    return "N/A";
  }
};

// Helper function to resolve file ID/object to URL
const resolveFileUrl = async (fileValue: any): Promise<string | null> => {
  if (!fileValue) {
    return null;
  }

  // If it's already a URL string
  if (typeof fileValue === "string") {
    if (fileValue.startsWith("http://") || fileValue.startsWith("https://")) {
      // Convert http to https if needed
      return fileValue.startsWith("http://")
        ? fileValue.replace("http://", "https://")
        : fileValue;
    }

    // Check if it's a JSON string (starts with [ or {)
    if (fileValue.trim().startsWith("[") || fileValue.trim().startsWith("{")) {
      try {
        const parsed = JSON.parse(fileValue);
        // Recursively resolve the parsed value
        return await resolveFileUrl(parsed);
      } catch (e) {
        // If parsing fails, it's not valid JSON, continue as regular string
        console.warn("Failed to parse JSON string:", e);
      }
    }

    // If it's a file ID (simple string), fetch the URL
    try {
      const fileResponse = await UploadService.getFileById({ id: fileValue });
      return (
        fileResponse?.file_path ??
        fileResponse?.file_path_thumbnail ??
        fileResponse?.file_path_optimized ??
        fileResponse?.url ??
        null
      );
    } catch (error) {
      console.warn(`Failed to fetch file for ID ${fileValue}:`, error);
      return null;
    }
  }

  // If it's an object (from CustomFileUpload - Array<object>)
  if (typeof fileValue === "object" && fileValue !== null) {
    // Check if it's an array (banner/thumbnail/attachments/photos are Array<object>)
    if (Array.isArray(fileValue)) {
      // Get first item from array
      const firstItem = fileValue[0];
      if (!firstItem) {
        return null;
      }

      // If first item is an object, extract URL directly (no API call needed)
      if (typeof firstItem === "object" && firstItem !== null) {
        // Priority: file_path_thumbnail > file_path_optimized > file_path > url > id
        // Always check for file_path properties first - they're already URLs, no API call needed
        if (
          firstItem.file_path_thumbnail &&
          typeof firstItem.file_path_thumbnail === "string"
        ) {
          return firstItem.file_path_thumbnail.startsWith("http://")
            ? firstItem.file_path_thumbnail.replace("http://", "https://")
            : firstItem.file_path_thumbnail;
        }
        if (
          firstItem.file_path_optimized &&
          typeof firstItem.file_path_optimized === "string"
        ) {
          return firstItem.file_path_optimized.startsWith("http://")
            ? firstItem.file_path_optimized.replace("http://", "https://")
            : firstItem.file_path_optimized;
        }
        if (firstItem.file_path && typeof firstItem.file_path === "string") {
          return firstItem.file_path.startsWith("http://")
            ? firstItem.file_path.replace("http://", "https://")
            : firstItem.file_path;
        }
        if (firstItem.url && typeof firstItem.url === "string") {
          return firstItem.url.startsWith("http://")
            ? firstItem.url.replace("http://", "https://")
            : firstItem.url;
        }
        // Only fetch by ID if we don't have any file_path/url properties
        // AND the id is a simple string (not an object or array)
        if (
          firstItem.id &&
          typeof firstItem.id === "string" &&
          firstItem.id.length > 0
        ) {
          // Double check: if id looks like it might be a URL or object, don't fetch
          if (
            !firstItem.id.startsWith("http") &&
            !firstItem.id.startsWith("[") &&
            !firstItem.id.startsWith("{")
          ) {
            return await resolveFileUrl(firstItem.id);
          }
        }
        // If we have an object but no extractable URL, return null
        return null;
      }
      // If array contains strings, resolve first one
      if (typeof firstItem === "string") {
        return await resolveFileUrl(firstItem);
      }
      return null;
    }

    // Single object (not array)
    // Priority: file_path_thumbnail > file_path_optimized > file_path > url > id
    if (fileValue.file_path_thumbnail) {
      return fileValue.file_path_thumbnail.startsWith("http://")
        ? fileValue.file_path_thumbnail.replace("http://", "https://")
        : fileValue.file_path_thumbnail;
    }
    if (fileValue.file_path_optimized) {
      return fileValue.file_path_optimized.startsWith("http://")
        ? fileValue.file_path_optimized.replace("http://", "https://")
        : fileValue.file_path_optimized;
    }
    if (fileValue.file_path) {
      return fileValue.file_path.startsWith("http://")
        ? fileValue.file_path.replace("http://", "https://")
        : fileValue.file_path;
    }
    if (fileValue.url) {
      return typeof fileValue.url === "string"
        ? fileValue.url.startsWith("http://")
          ? fileValue.url.replace("http://", "https://")
          : fileValue.url
        : await resolveFileUrl(fileValue.url);
    }
    // If only ID is present (string), fetch the file
    // But only if we don't have any file_path already
    if (
      fileValue.id &&
      typeof fileValue.id === "string" &&
      fileValue.id.length > 0
    ) {
      // Double check: if id looks like it might be a URL or object/array, don't fetch
      if (
        !fileValue.id.startsWith("http") &&
        !fileValue.id.startsWith("[") &&
        !fileValue.id.startsWith("{")
      ) {
        return await resolveFileUrl(fileValue.id);
      }
    }

    // If we reach here, the object doesn't have extractable URLs
    return null;
  }

  return null;
};

interface MediaFile {
  id: string;
  file_url: string;
  file_type: string;
  file_size: number | null;
}

interface Publication {
  id: string;
  media_type: string;
  media_name: string | null;
  url: string | null;
  file_url: string | null;
  publication_date: string | null;
}

interface Submission {
  id: string;
  event_id: string;
  schoolcontact?: string;
  teachername?: string;
  short_description?: string;
  document_url?: string;
  status: string;
  score: number | null;
  admin_comments?: string | null;
  submitted_at?: string | null;
  reviewed_at?: string | null;
  created_at?: string;
  schools: {
    school_name: string;
    kc_no: string;
    principal_name: string;
    contact_number: string;
    email: string;
    kendra_name: string;
  };
  events: {
    title: string;
    description: string;
    start_date: string;
    end_date: string;
    location: string;
  };
  teachers: {
    name: string;
    email: string;
    mobile: string;
  } | null;
  media_files?: MediaFile[];
  publications?: Publication[];
  rawData?: any; // Store raw submission data for displaying all schema fields
}

const AdminSubmissionReview = () => {
  const { id: submissionId } = useParams();
  const navigate = useNavigate();
  const getLink = useKarunaLink();
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(true);
  const [submission, setSubmission] = useState<Submission | null>(null);
  const [score, setScore] = useState<number | null>(null);
  const [comments, setComments] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);
  const [activeTab, setActiveTab] = useState("details");
  const [resolvedFiles, setResolvedFiles] = useState<{
    photos: string[];
    photos2: string[];
    photos3: string[];
    photos4: string[];
    photos5: string[];
    /** URLs from API media_files + nested mediaUploads when top-level photos* are empty */
    mediaFileUrls: string[];
    descriptiondocument: string | null;
    printscancopy: string | null;
  }>({
    photos: [],
    photos2: [],
    photos3: [],
    photos4: [],
    photos5: [],
    mediaFileUrls: [],
    descriptiondocument: null,
    printscancopy: null,
  });
  const [activityBannerImage, setActivityBannerImage] = useState<string | null>(
    null
  );

  // Fetch submission data
  const {
    data: submissionData,
    isLoading: submissionLoading,
    error: submissionError,
  } = useQuery({
    queryKey: ["admin-submission", SUBMISSION_SCHEMA_NAME, submissionId],
    queryFn: async () => {
      if (!submissionId) {
        return null;
      }
      try {
        const data = await DynamicModuleService.getItemById(
          SUBMISSION_SCHEMA_NAME,
          submissionId
        );
        const result = data?.data ?? data ?? null;
        console.log("🔍 Raw API response:", {
          hasData: !!result,
          keys: result ? Object.keys(result) : [],
          photos: result?.photos,
          photos2: result?.photos2,
          photos3: result?.photos3,
          photos4: result?.photos4,
          photos5: result?.photos5,
        });
        return result;
      } catch (error) {
        console.error("Error fetching submission:", error);
        throw error;
      }
    },
    enabled: !!submissionId,
  });

  // Fetch all activities from Activity Management schema with full details
  const { data: activitiesData } = useQuery({
    queryKey: ["activities-full", ACTIVITY_SCHEMA_NAME],
    queryFn: async () => {
      try {
        // First get grid data to get all activity IDs
        const activitiesList =
          await DynamicModuleService.getGridColItemsAllPages(
            ACTIVITY_SCHEMA_NAME
          );

        const activitiesWithFullData = await mapWithConcurrency(
          activitiesList,
          DEFAULT_API_FETCH_CONCURRENCY,
          async (activity: any) => {
            const activityId = activity.id ?? activity._id;
            if (!activityId) {
              return activity;
            }

            try {
              const fullData = await DynamicModuleService.getItemById(
                ACTIVITY_SCHEMA_NAME,
                activityId
              );
              const data = fullData?.data ?? fullData ?? activity;
              return { ...activity, ...data };
            } catch (err) {
              console.warn(
                `Could not fetch full data for activity ${activityId}:`,
                err
              );
              return activity;
            }
          }
        );

        return activitiesWithFullData;
      } catch (error) {
        console.error("Error fetching activities:", error);
        return [];
      }
    },
  });

  // Fetch school profiles
  const { data: schoolProfilesData } = useQuery({
    queryKey: ["school-profiles", SCHOOL_PROFILE_SCHEMA_NAME],
    queryFn: async () => {
      try {
        return await DynamicModuleService.getGridColItemsAllPages(
          SCHOOL_PROFILE_SCHEMA_NAME
        );
      } catch (error) {
        console.error("Error fetching school profiles:", error);
        return [];
      }
    },
  });

  // Transform and set submission data
  useEffect(() => {
    const processSubmission = async () => {
      if (submissionLoading) {
        setLoading(true);
        return;
      }

      if (submissionError) {
        setLoading(false);
        toast({
          title: "Error",
          description: "Failed to load submission details",
          variant: "destructive",
        });
        return;
      }

      if (!submissionData) {
        setLoading(false);
        return;
      }

      try {
        const submission = submissionData as any;
        console.log("📋 Submission data:", submission);
        console.log("📋 Submission keys:", Object.keys(submission));
        console.log("📋 Photo fields check:", {
          photos: submission.photos,
          photos2: submission.photos2,
          photos3: submission.photos3,
          photos4: submission.photos4,
          photos5: submission.photos5,
          hasPhotos: !!submission.photos,
          hasPhotos2: !!submission.photos2,
          hasPhotos3: !!submission.photos3,
          hasPhotos4: !!submission.photos4,
          hasPhotos5: !!submission.photos5,
        });

        // Get program name from submission
        const programValue = submission.program ?? "";
        const programNameMap: Record<string, string> = {
          intraschool: "Organising Intra School Programmes",
          interschool: "Organising Inter School Programmes",
          participationinter:
            "Participation in Inter-School Competitions/Programmes",
          publicrelation: "Public Relation Programmes",
          karunaclub: "Karuna Club – Internal / External Growth",
          nationallevel:
            "Organising / Participation in National Level Programme",
        };
        const programName = programValue
          ? (programNameMap[programValue] ?? programValue)
          : "";

        // Try to find matching activity
        // Check if submission has activity_id or activity reference
        const activityId =
          submission.activity_id ??
          submission.activityid ??
          submission.activity ??
          "";

        let activity: any = null;
        if (activitiesData && activitiesData.length > 0) {
          // First try to match by activity_id if available
          if (activityId) {
            activity = activitiesData.find((act: any) => {
              const actId = String(act.id ?? act._id ?? "").trim();
              return actId === String(activityId).trim();
            });
          }

          // If no match by ID, try to match by program name
          if (!activity && programName) {
            activity = activitiesData.find((act: any) => {
              const actTitle = act.title ?? act.activitytitle ?? act.name ?? "";
              const actTitleLower = actTitle.toLowerCase();
              const programNameLower = programName.toLowerCase();
              const titleIncludesProgram =
                actTitleLower.includes(programNameLower);
              const programIncludesTitle =
                programNameLower.includes(actTitleLower);
              return titleIncludesProgram ? true : programIncludesTitle;
            });
          }

          // Don't use fallback - if no match found, activity will be null
          // This ensures we don't show wrong banner/title/location
        }

        console.log("✅ Activity data:", activity ? "Found" : "Not found");
        if (activity) {
          console.log("📋 Activity details:", {
            title: activity.title ?? activity.activitytitle ?? activity.name,
            location: activity.location ?? activity.venue ?? activity.place,
            start_date:
              activity.start_date ??
              activity.startdate ??
              activity.startDate ??
              activity.start,
            end_date:
              activity.end_date ??
              activity.enddate ??
              activity.endDate ??
              activity.end,
          });
        }

        // Find school profile by contact
        const submissionContact = normalizeMobileNumber(
          submission.schoolcontact ??
            submission.contact ??
            submission.school_contact ??
            ""
        );
        const schoolProfile = schoolProfilesData?.find((profile: any) => {
          const profileContact = normalizeMobileNumber(
            profile.contact ??
              profile.school_contact ??
              profile.schoolcontact ??
              ""
          );
          return profileContact === submissionContact && profileContact !== "";
        });

        // Transform to expected structure with all schema fields
        const transformedSubmission: Submission = {
          id: submission.id ?? submission._id ?? "",
          event_id: "", // No event_id in schema
          schoolcontact: submissionContact,
          teachername: submission.teachername,
          short_description:
            submission.short_description ?? submission.description,
          document_url:
            submission.document_url ??
            submission.descriptiondocument ??
            submission.documenturl,
          status: submission.status ?? "pending",
          score: submission.score ?? null,
          admin_comments:
            submission.admin_comments ??
            submission.admincomments ??
            submission.comments ??
            null,
          submitted_at:
            submission.submitted_at ??
            submission.created_on ??
            submission.created_at,
          reviewed_at: submission.reviewed_at ?? submission.reviewed_on,
          created_at:
            submission.created_at ??
            submission.created_on ??
            submission.submitted_at,
          // Store raw submission data for displaying all fields
          rawData: submission,
          schools: {
            school_name:
              schoolProfile?.schoolname ??
              submission.schoolname ??
              "Unknown School",
            kc_no: schoolProfile?.kcno ?? submission.kcno ?? "N/A",
            principal_name:
              schoolProfile?.principalname ?? submission.principalname ?? "N/A",
            contact_number: submissionContact || "N/A",
            email:
              schoolProfile?.email ??
              submission.schoolemail ??
              submission.email ??
              "N/A",
            kendra_name:
              schoolProfile?.kendra ?? submission.nearestkendra ?? "N/A",
          },
          events: {
            // Priority: submission's own title/location fields > activity fields > program name
            title:
              submission.title ??
              submission.event_title ??
              submission.activitytitle ??
              submission.activity_title ??
              activity?.title ??
              activity?.activitytitle ??
              activity?.name ??
              programName ??
              "Unknown Activity",
            description:
              submission.description ??
              submission.event_description ??
              activity?.description ??
              activity?.desc ??
              "",
            start_date:
              submission.start_date ??
              submission.startdate ??
              submission.event_start_date ??
              activity?.start_date ??
              activity?.startdate ??
              activity?.startDate ??
              activity?.start ??
              "",
            end_date:
              submission.end_date ??
              submission.enddate ??
              submission.event_end_date ??
              activity?.end_date ??
              activity?.enddate ??
              activity?.endDate ??
              activity?.end ??
              "",
            location:
              submission.location ??
              submission.event_location ??
              submission.venue ??
              submission.place ??
              activity?.location ??
              activity?.venue ??
              activity?.place ??
              activity?.location_name ??
              "",
          },
          teachers: submission.teachername
            ? {
                name: submission.teachername,
                email: submission.teacheremail ?? "",
                mobile: submission.teachermobile ?? "",
              }
            : null,
          media_files: submission.media_files ?? [],
          publications: submission.publications ?? [],
        };

        setSubmission(transformedSubmission);
        {
          const s = transformedSubmission.score;
          if (s === null || s === undefined || s === "") {
            setScore(null);
          } else {
            const n = Number(s);
            setScore(Number.isFinite(n) ? n : null);
          }
        }
        setComments(
          transformedSubmission.admin_comments ??
            transformedSubmission.rawData?.comments ??
            ""
        );

        // Resolve file IDs to URLs for all 5 photo fields
        // Handle both string IDs and arrays
        const resolvePhotos = async (photoValue: any): Promise<string[]> => {
          const resolved: string[] = [];

          // If it's a string (single ID), convert to array
          if (typeof photoValue === "string" && photoValue.trim() !== "") {
            const url = await resolveFileUrl(photoValue);
            if (url) {
              resolved.push(url);
            }
          }
          // If it's an array, process each item
          else if (photoValue && Array.isArray(photoValue)) {
            for (const photo of photoValue) {
              const url = await resolveFileUrl(photo);
              if (url) {
                resolved.push(url);
              }
            }
          }

          return resolved;
        };

        // Access photos from raw submission data
        // Photos can be stored as string IDs or arrays
        const resolvedPhotos = await resolvePhotos(submission.photos);
        const resolvedPhotos2 = await resolvePhotos(submission.photos2);
        const resolvedPhotos3 = await resolvePhotos(submission.photos3);
        const resolvedPhotos4 = await resolvePhotos(submission.photos4);
        const resolvedPhotos5 = await resolvePhotos(submission.photos5);

        // Nested Formily path (mediaUploads.photos) when top-level photos* are unset
        const nestedMediaPhotos =
          submission.mediaUploads?.photos ??
          (submission.rawData as any)?.mediaUploads?.photos ??
          (submission.rawData as any)?.mediauploads?.photos;
        const resolvedNestedPhotos = await resolvePhotos(nestedMediaPhotos);

        // API often returns media_files[] with file_url or id — grid used to ignore these
        const fromMediaFiles: string[] = [];
        for (const m of (submission.media_files ?? []) as MediaFile[]) {
          if (!m) {
            continue;
          }
          if (
            m.file_url &&
            typeof m.file_url === "string" &&
            m.file_url.trim() !== ""
          ) {
            const u = m.file_url.startsWith("http://")
              ? m.file_url.replace("http://", "https://")
              : m.file_url;
            if (/^https?:\/\//i.test(u)) {
              fromMediaFiles.push(u);
            }
          } else if (m.id) {
            const u = await resolveFileUrl(m.id);
            if (u) {
              fromMediaFiles.push(u);
            }
          }
        }

        const mediaFileUrls = [
          ...fromMediaFiles,
          ...resolvedNestedPhotos,
        ].filter((url, i, arr) => url && arr.indexOf(url) === i);

        console.log("📸 Photo resolution:", {
          resolvedCounts: {
            photos: resolvedPhotos.length,
            photos2: resolvedPhotos2.length,
            photos3: resolvedPhotos3.length,
            photos4: resolvedPhotos4.length,
            photos5: resolvedPhotos5.length,
          },
          rawData: {
            photos: submission.photos,
            photos2: submission.photos2,
            photos3: submission.photos3,
            photos4: submission.photos4,
            photos5: submission.photos5,
          },
          submissionKeys: Object.keys(submission),
          media_files: submission.media_files,
          mediaFileUrlsCount: mediaFileUrls.length,
        });

        // Resolve files - schema uses lowercase field names
        const descriptionDocUrl = await resolveFileUrl(
          submission.descriptiondocument
        );
        const printScanCopyUrl = await resolveFileUrl(submission.printscancopy);

        setResolvedFiles({
          photos: resolvedPhotos,
          photos2: resolvedPhotos2,
          photos3: resolvedPhotos3,
          photos4: resolvedPhotos4,
          photos5: resolvedPhotos5,
          mediaFileUrls,
          descriptiondocument: descriptionDocUrl,
          printscancopy: printScanCopyUrl,
        });

        // Resolve banner image - check submission's banner first, then activity's banner
        // Priority: submission.banner > submission.banner_image > activity.banner > activity.thumbnail
        let bannerUrl: string | null = null;

        // First, check if submission has its own banner field
        const submissionBannerValue =
          submission.banner ?? submission.banner_image ?? submission.banner_url;

        if (submissionBannerValue) {
          try {
            bannerUrl = await resolveFileUrl(submissionBannerValue);
            if (bannerUrl) {
              console.log("✅ Submission banner resolved:", bannerUrl);
            }
          } catch (error) {
            console.warn("⚠️ Failed to resolve submission banner:", error);
          }
        }

        // If no submission banner, try activity banner
        if (!bannerUrl && activity) {
          const activityBannerValue =
            activity.banner ?? activity.banner_url ?? activity.banner_image;
          if (activityBannerValue) {
            try {
              bannerUrl = await resolveFileUrl(activityBannerValue);
              if (bannerUrl) {
                console.log("✅ Activity banner resolved:", bannerUrl);
              } else {
                console.warn(
                  "⚠️ Activity banner value exists but could not resolve URL:",
                  activityBannerValue
                );
              }
            } catch (error) {
              console.warn("⚠️ Failed to resolve activity banner:", error);
            }
          } else {
            // Fallback to thumbnail if banner not available (thumbnail is also Array<object>)
            const thumbnailValue = activity.thumbnail;
            if (thumbnailValue) {
              try {
                bannerUrl = await resolveFileUrl(thumbnailValue);
                if (bannerUrl) {
                  console.log(
                    "✅ Activity thumbnail used as banner:",
                    bannerUrl
                  );
                }
              } catch (error) {
                console.warn("⚠️ Failed to resolve activity thumbnail:", error);
              }
            }
          }
        }

        if (bannerUrl) {
          setActivityBannerImage(bannerUrl);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error transforming submission data:", error);
        toast({
          title: "Error",
          description: "Failed to load submission details",
          variant: "destructive",
        });
        setLoading(false);
      }
    };

    processSubmission();
  }, [
    submissionData,
    submissionLoading,
    submissionError,
    activitiesData,
    schoolProfilesData,
    toast,
  ]);

  const handleApprove = async () => {
    if (!submissionId) {
      toast({
        title: "Error",
        description: "Submission ID is missing",
        variant: "destructive",
      });
      return;
    }

    setActionLoading(true);
    try {
      // Fetch the current submission data to preserve all existing fields
      let currentRecord: any;
      try {
        const response = await DynamicModuleService.getItemById(
          SUBMISSION_SCHEMA_NAME,
          submissionId
        );
        currentRecord = response?.data ?? response ?? submission?.rawData;
        console.log("📋 Current record from API:", currentRecord);
      } catch (fetchError) {
        console.warn(
          "⚠️ Could not fetch full record, using state data:",
          fetchError
        );
        currentRecord = submission?.rawData ?? {};
      }

      // Remove meta fields first
      const cleanedData = removeMetaFields(currentRecord);

      // Build update payload - merge existing data with status update
      // Note: Don't include 'schema' field in the payload - it's metadata, not data
      const updatePayload: any = {
        ...cleanedData,
        status: "approved",
        score:
          typeof score === "number" && score > 0 ? String(score) : undefined,
        comments: comments || undefined,
        admin_comments: comments || undefined,
        admincomments: comments || undefined,
        reviewed_at: new Date().toISOString(),
        reviewed_on: new Date().toISOString(),
      };

      // Remove any undefined or null values that might cause issues
      Object.keys(updatePayload).forEach(key => {
        if (
          updatePayload[key] === undefined ||
          updatePayload[key] === null ||
          updatePayload[key] === ""
        ) {
          delete updatePayload[key];
        }
      });

      console.log("💾 Updating with complete payload:", updatePayload);
      console.log("📝 Comments being saved:", comments);
      console.log("📊 Score being saved:", score);

      await DynamicModuleService.updateItem(
        SUBMISSION_SCHEMA_NAME,
        submissionId,
        updatePayload
      );

      // Invalidate queries to refresh data
      queryClient.invalidateQueries({
        queryKey: ["admin-submission", SUBMISSION_SCHEMA_NAME, submissionId],
      });
      queryClient.invalidateQueries({
        queryKey: ["admin-submissions", SUBMISSION_SCHEMA_NAME],
      });
      queryClient.invalidateQueries({
        queryKey: ["school-submissions", SUBMISSION_SCHEMA_NAME],
      });

      toast({
        title: "Success",
        description: "Submission approved successfully",
      });
      navigate(getLink("/admin/submissions"));
    } catch (_error: any) {
      console.error("❌ Error approving submission:", _error);
      const errorMessage =
        _error?.response?.data?.message ??
        _error?.response?.data?.error ??
        _error?.message ??
        "Failed to approve submission";
      toast({
        title: "Error",
        description: errorMessage ?? "Failed to approve submission",
        variant: "destructive",
      });
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpdateEvaluation = async () => {
    if (!submissionId) {
      toast({
        title: "Error",
        description: "Submission ID is missing",
        variant: "destructive",
      });
      return;
    }

    // Validate required fields
    if (
      score === null ||
      typeof score !== "number" ||
      score <= 0 ||
      score > 100
    ) {
      toast({
        title: "Validation Error",
        description:
          "Please enter a score (1-100) before saving the evaluation.",
        variant: "destructive",
      });
      return;
    }

    if (!comments || comments.trim() === "") {
      toast({
        title: "Validation Error",
        description:
          "Please enter review comments before saving the evaluation.",
        variant: "destructive",
      });
      return;
    }

    setActionLoading(true);
    try {
      // Fetch the current submission data to preserve all existing fields
      let currentRecord: any;
      try {
        const response = await DynamicModuleService.getItemById(
          SUBMISSION_SCHEMA_NAME,
          submissionId
        );
        currentRecord = response?.data ?? response ?? submission?.rawData;
        console.log("📋 Current record from API:", currentRecord);
      } catch (fetchError) {
        console.warn(
          "⚠️ Could not fetch full record, using state data:",
          fetchError
        );
        currentRecord = submission?.rawData ?? {};
      }

      // Remove meta fields first
      const cleanedData = removeMetaFields(currentRecord);

      // Build update payload - merge existing data with score and comments update
      // Note: Don't include 'schema' field in the payload - it's metadata, not data
      const updatePayload: any = {
        ...cleanedData,
        score:
          typeof score === "number" && score > 0 ? String(score) : undefined,
        comments: comments || undefined,
        admin_comments: comments || undefined,
        admincomments: comments || undefined,
      };

      // Remove any undefined or null values that might cause issues
      Object.keys(updatePayload).forEach(key => {
        if (
          updatePayload[key] === undefined ||
          updatePayload[key] === null ||
          updatePayload[key] === ""
        ) {
          delete updatePayload[key];
        }
      });

      console.log("💾 Updating evaluation with payload:", updatePayload);
      console.log("📝 Comments being saved:", comments);
      console.log("📊 Score being saved:", score);

      await DynamicModuleService.updateItem(
        SUBMISSION_SCHEMA_NAME,
        submissionId,
        updatePayload
      );

      // Invalidate queries to refresh data
      queryClient.invalidateQueries({
        queryKey: ["admin-submission", SUBMISSION_SCHEMA_NAME, submissionId],
      });
      queryClient.invalidateQueries({
        queryKey: ["admin-submissions", SUBMISSION_SCHEMA_NAME],
      });
      queryClient.invalidateQueries({
        queryKey: ["school-submissions", SUBMISSION_SCHEMA_NAME],
      });

      toast({
        title: "Success",
        description: "Evaluation updated successfully",
      });
    } catch (_error: any) {
      console.error("❌ Error updating evaluation:", _error);
      const errorMessage =
        _error?.response?.data?.message ??
        _error?.response?.data?.error ??
        _error?.message ??
        "Failed to update evaluation";
      toast({
        title: "Error",
        description: errorMessage ?? "Failed to update evaluation",
        variant: "destructive",
      });
    } finally {
      setActionLoading(false);
    }
  };

  const handleReject = async () => {
    if (!submissionId) {
      toast({
        title: "Error",
        description: "Submission ID is missing",
        variant: "destructive",
      });
      return;
    }

    setActionLoading(true);
    try {
      // Fetch the current submission data to preserve all existing fields
      let currentRecord: any;
      try {
        const response = await DynamicModuleService.getItemById(
          SUBMISSION_SCHEMA_NAME,
          submissionId
        );
        currentRecord = response?.data ?? response ?? submission?.rawData;
        console.log("📋 Current record from API:", currentRecord);
      } catch (fetchError) {
        console.warn(
          "⚠️ Could not fetch full record, using state data:",
          fetchError
        );
        currentRecord = submission?.rawData ?? {};
      }

      // Remove meta fields first
      const cleanedData = removeMetaFields(currentRecord);

      // When rejecting, explicitly delete score and evaluation fields from cleanedData
      // so they are not included in the update payload
      delete cleanedData.score;
      delete cleanedData.admin_comments;
      delete cleanedData.comments;
      delete cleanedData.review_comments;
      delete cleanedData.admincomments;
      delete cleanedData.reviewcomments;
      delete cleanedData.evaluation_score;
      delete cleanedData.evaluation_comments;
      // Also try common field name variations
      delete cleanedData.Score;
      delete cleanedData.Admin_Comments;
      delete cleanedData.Comments;

      // Build update payload - merge existing data with status update
      // Note: Don't include 'schema' field in the payload - it's metadata, not data
      const updatePayload: any = {
        ...cleanedData,
        status: "rejected",
        reviewed_at: new Date().toISOString(),
        reviewed_on: new Date().toISOString(),
      };

      // Explicitly set score and evaluation fields to empty string to ensure backend clears them
      // (some backends require explicit empty values to clear fields)
      updatePayload.score = "";
      updatePayload.admin_comments = "";
      updatePayload.comments = "";
      updatePayload.review_comments = "";
      updatePayload.admincomments = "";
      updatePayload.reviewcomments = "";
      updatePayload.evaluation_score = "";
      updatePayload.evaluation_comments = "";

      // Remove any undefined values, but keep empty strings for fields we want to clear
      Object.keys(updatePayload).forEach(key => {
        if (updatePayload[key] === undefined) {
          delete updatePayload[key];
        }
      });

      console.log("💾 Updating with complete payload:", updatePayload);

      await DynamicModuleService.updateItem(
        SUBMISSION_SCHEMA_NAME,
        submissionId,
        updatePayload
      );

      // Invalidate queries to refresh data
      queryClient.invalidateQueries({
        queryKey: ["admin-submission", SUBMISSION_SCHEMA_NAME, submissionId],
      });
      queryClient.invalidateQueries({
        queryKey: ["admin-submissions", SUBMISSION_SCHEMA_NAME],
      });
      queryClient.invalidateQueries({
        queryKey: ["school-submissions", SUBMISSION_SCHEMA_NAME],
      });

      toast({
        title: "Success",
        description: "Submission rejected",
      });
      setShowRejectDialog(false);
      navigate(getLink("/admin/submissions"));
    } catch (_error: any) {
      console.error("❌ Error rejecting submission:", _error);
      const errorMessage =
        _error?.response?.data?.message ??
        _error?.response?.data?.error ??
        _error?.message ??
        "Failed to reject submission";
      toast({
        title: "Error",
        description: errorMessage ?? "Failed to reject submission",
        variant: "destructive",
      });
    } finally {
      setActionLoading(false);
    }
  };

  const getStatusBadge = (status: string) => {
    const statusConfig = {
      pending: { color: "bg-yellow-500", label: "Pending" },
      approved: { color: "bg-green-500", label: "Approved" },
      rejected: { color: "bg-red-500", label: "Rejected" },
    };

    const config =
      statusConfig[status as keyof typeof statusConfig] ?? statusConfig.pending;

    return (
      <Badge className={`${config.color} text-white`}>{config.label}</Badge>
    );
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex min-h-[400px] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </AdminLayout>
    );
  }

  if (!submission) {
    return (
      <AdminLayout>
        <div className="py-12 text-center">
          <h2 className="text-2xl font-bold">Submission Not Found</h2>
          <Button
            className="mt-4"
            onClick={() => navigate(getLink("/admin/submissions"))}
          >
            Back to Submissions
          </Button>
        </div>
      </AdminLayout>
    );
  }

  // All displayable image URLs (slots + media_files / nested uploads — deduped)
  const allPhotoUrls = [
    ...resolvedFiles.photos,
    ...resolvedFiles.photos2,
    ...resolvedFiles.photos3,
    ...resolvedFiles.photos4,
    ...resolvedFiles.photos5,
    ...resolvedFiles.mediaFileUrls,
  ].filter(Boolean);
  const uniquePhotoUrls = [...new Set(allPhotoUrls)];

  const bannerImage =
    activityBannerImage ??
    (submission
      ? uniquePhotoUrls.length > 0
        ? uniquePhotoUrls[0]
        : submission.media_files?.find((m: MediaFile) =>
            (m.file_type ?? "").startsWith("image/")
          )?.file_url
      : null);

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              size="icon"
              onClick={() => navigate(getLink("/admin/submissions"))}
              className="shrink-0"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <div>
              <h1 className="text-3xl font-bold">Review Submission</h1>
              <p className="mt-1 text-lg text-muted-foreground">
                Activity Title:{" "}
                <span className="font-bold">
                  {submission.events?.title ??
                    (submission.rawData as any)?.title ??
                    (submission.rawData as any)?.event_title ??
                    (submission.rawData as any)?.activitytitle ??
                    (submission.rawData as any)?.activity_title ??
                    "Unknown Activity"}
                </span>
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {submission.status !== "pending" &&
              submission.status !== "rejected" &&
              submission.score && (
                <div className="flex items-center gap-2 rounded-lg bg-primary/10 px-4 py-2">
                  <User className="h-4 w-4 text-primary" />
                  <span className="font-semibold text-primary">
                    {submission.score}/100
                  </span>
                </div>
              )}
            {getStatusBadge(submission.status)}
          </div>
        </div>

        {/* Summary Cards */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <Card className="border-border/50">
            <CardContent className="flex items-center gap-3 p-4">
              <div className="rounded-lg bg-blue-100 p-2 dark:bg-blue-900/20">
                <Calendar className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Submitted</p>
                <p className="font-semibold">
                  {submission.submitted_at
                    ? formatDate(submission.submitted_at)
                    : "N/A"}
                </p>
              </div>
            </CardContent>
          </Card>
          <Card className="border-border/50">
            <CardContent className="flex items-center gap-3 p-4">
              <div className="rounded-lg bg-purple-100 p-2 dark:bg-purple-900/20">
                <School className="h-5 w-5 text-purple-600 dark:text-purple-400" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">KC Number</p>
                <p className="font-semibold">{submission.schools.kc_no}</p>
              </div>
            </CardContent>
          </Card>
          <Card className="border-border/50">
            <CardContent className="flex items-center gap-3 p-4">
              <div className="rounded-lg bg-green-100 p-2 dark:bg-green-900/20">
                <ImageIcon className="h-5 w-5 text-green-600 dark:text-green-400" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Media Files</p>
                <p className="font-semibold">{uniquePhotoUrls.length} files</p>
              </div>
            </CardContent>
          </Card>
          <Card className="border-border/50">
            <CardContent className="flex items-center gap-3 p-4">
              <div className="rounded-lg bg-orange-100 p-2 dark:bg-orange-900/20">
                <FileText className="h-5 w-5 text-orange-600 dark:text-orange-400" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Publications</p>
                <p className="font-semibold">
                  {submission.publications?.length ?? 0} entries
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Tabs Navigation */}
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-4 lg:w-auto">
            <TabsTrigger value="details">Details</TabsTrigger>
            <TabsTrigger value="media">Media</TabsTrigger>
            <TabsTrigger value="publications">Publications</TabsTrigger>
            <TabsTrigger value="history">History</TabsTrigger>
          </TabsList>

          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
            {/* Main Content */}
            <div className="space-y-6 lg:col-span-2">
              <TabsContent value="details" className="mt-0 space-y-6">
                {/* Banner Image from Activity Management */}
                {bannerImage && (
                  <div className="relative h-64 w-full overflow-hidden rounded-lg">
                    <img
                      src={bannerImage}
                      alt="Activity banner"
                      className="h-full w-full object-cover"
                      onError={e => {
                        console.error(
                          `Failed to load banner image: ${bannerImage}`
                        );
                        (e.target as HTMLImageElement).style.display = "none";
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                    <div className="absolute bottom-6 left-6 text-white">
                      <h2 className="text-2xl font-bold drop-shadow-lg">
                        {submission.events?.title ??
                          (submission.rawData as any)?.title ??
                          (submission.rawData as any)?.event_title ??
                          (submission.rawData as any)?.activitytitle ??
                          (submission.rawData as any)?.activity_title ??
                          "Unknown Activity"}
                      </h2>
                      {(submission.events?.location ??
                        (submission.rawData as any)?.location ??
                        (submission.rawData as any)?.event_location) && (
                        <p className="mt-1 text-base opacity-95 drop-shadow-md">
                          {submission.events?.location ??
                            (submission.rawData as any)?.location ??
                            (submission.rawData as any)?.event_location}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* Submission Report */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <FileText className="h-5 w-5" />
                      Submission Report
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <p className="text-muted-foreground">
                      {submission.rawData?.description ??
                        submission.short_description ??
                        "No description provided"}
                    </p>
                    {(resolvedFiles.descriptiondocument ??
                      submission.document_url ??
                      submission.rawData?.descriptiondocument) && (
                      <Button
                        variant="outline"
                        className="w-full sm:w-auto"
                        onClick={() =>
                          window.open(
                            resolvedFiles.descriptiondocument ??
                              submission.document_url ??
                              submission.rawData?.descriptiondocument ??
                              "",
                            "_blank"
                          )
                        }
                      >
                        <Download className="mr-2 h-4 w-4" />
                        Download Full Report
                      </Button>
                    )}
                  </CardContent>
                </Card>

                {/* Section A: Basic School & Contact Details */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <School className="h-5 w-5" />
                      Section A: Basic School & Contact Details
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div>
                        <Label className="text-muted-foreground">KC No</Label>
                        <p className="mt-1 font-medium">
                          {submission.rawData?.kcno ?? submission.schools.kc_no}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          School Name
                        </Label>
                        <p className="mt-1 font-medium">
                          {submission.rawData?.schoolname ??
                            submission.schools.school_name}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          Nearest Karuna Kendra Name
                        </Label>
                        <p className="mt-1">
                          {submission.rawData?.nearestkendra ??
                            submission.schools.kendra_name}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          School Principal&apos;s Name
                        </Label>
                        <p className="mt-1">
                          {submission.rawData?.principalname ??
                            submission.schools.principal_name}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          School Contact Number
                        </Label>
                        <p className="mt-1">
                          {submission.rawData?.schoolcontact ??
                            submission.schools.contact_number}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          School Email ID
                        </Label>
                        <p className="mt-1">
                          {submission.rawData?.schoolemail ??
                            submission.schools.email}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Section B: Karuna Club Teacher In-Charge */}
                {submission.rawData?.teachername && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center gap-2">
                        <User className="h-5 w-5" />
                        Section B: Karuna Club Teacher In-Charge
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                        <div>
                          <Label className="text-muted-foreground">Name</Label>
                          <p className="mt-1">
                            {submission.rawData?.teachername ??
                              submission.teachers?.name}
                          </p>
                        </div>
                        <div>
                          <Label className="text-muted-foreground">
                            Mobile Number
                          </Label>
                          <p className="mt-1">
                            {submission.rawData?.teachermobile ??
                              submission.teachers?.mobile}
                          </p>
                        </div>
                        <div>
                          <Label className="text-muted-foreground">
                            Email ID
                          </Label>
                          <p className="mt-1">
                            {submission.rawData?.teacheremail ??
                              submission.teachers?.email}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Section C: Event Program Details */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <Calendar className="h-5 w-5" />
                      Section C: Event Program Details
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div>
                        <Label className="text-muted-foreground">
                          Select State
                        </Label>
                        <p className="mt-1">
                          {submission.rawData?.state
                            ? submission.rawData.state
                                .split("_")
                                .map(
                                  (w: string) =>
                                    w.charAt(0).toUpperCase() + w.slice(1)
                                )
                                .join(" ")
                            : "N/A"}
                        </p>
                      </div>
                      <div>
                        <Label className="text-muted-foreground">
                          Select Program
                        </Label>
                        <p className="mt-1 font-medium">
                          {(() => {
                            const programValue =
                              submission.rawData?.program ?? "";
                            const programNameMap: Record<string, string> = {
                              intraschool: "Organising Intra School Programmes",
                              interschool: "Organising Inter School Programmes",
                              participationinter:
                                "Participation in Inter-School Competitions/Programmes",
                              publicrelation: "Public Relation Programmes",
                              karunaclub:
                                "Karuna Club – Internal / External Growth",
                              nationallevel:
                                "Organising / Participation in National Level Programme",
                            };
                            return programValue
                              ? (programNameMap[programValue] ?? programValue)
                              : "N/A";
                          })()}
                        </p>
                      </div>
                      <div className="sm:col-span-2">
                        <Label className="text-muted-foreground">
                          Short Description
                        </Label>
                        <p className="mt-1 whitespace-pre-wrap">
                          {submission.rawData?.description ??
                            submission.short_description ??
                            "N/A"}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="media" className="mt-0 space-y-6">
                {/* Section D: Media Uploads */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <ImageIcon className="h-5 w-5" />
                      Section D: Media Uploads
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                      Photos of Program (4-5 photos required)
                    </p>
                  </CardHeader>
                  <CardContent>
                    {(() => {
                      const gridPhotos = uniquePhotoUrls;

                      return gridPhotos.length > 0 ? (
                        <div className="grid grid-cols-3 gap-4">
                          {gridPhotos.map((photoUrl: string, index: number) => (
                            <div
                              key={photoUrl}
                              className="group relative aspect-video overflow-hidden rounded-lg border"
                            >
                              <img
                                src={photoUrl}
                                alt={`${index + 1}`}
                                className="h-full w-full object-cover transition-transform group-hover:scale-105"
                                onError={e => {
                                  console.error(
                                    `Failed to load image: ${photoUrl}`
                                  );
                                  (e.target as HTMLImageElement).style.display =
                                    "none";
                                }}
                              />
                              <a
                                href={photoUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute inset-0 flex items-center justify-center bg-black/60 opacity-0 transition-opacity group-hover:opacity-100"
                              >
                                <Download className="h-8 w-8 text-white" />
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="py-8 text-center text-muted-foreground">
                          No photos uploaded
                        </p>
                      );
                    })()}
                  </CardContent>
                </Card>

                {/* Video Links */}
                {[
                  submission.rawData?.videolink1,
                  submission.rawData?.videolink2,
                  submission.rawData?.videolink3,
                ].some(Boolean) && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center gap-2">
                        <ImageIcon className="h-5 w-5" />
                        Video Links
                      </CardTitle>
                      <p className="text-sm text-muted-foreground">
                        Additional video documentation
                      </p>
                    </CardHeader>
                    <CardContent>
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                        {submission.rawData?.videolink1 && (
                          <Card className="p-4">
                            <Label className="text-muted-foreground">
                              Video Link 1
                            </Label>
                            <a
                              href={submission.rawData.videolink1}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="mt-1 block truncate text-primary hover:underline"
                            >
                              {submission.rawData.videolink1}
                            </a>
                          </Card>
                        )}
                        {submission.rawData?.videolink2 && (
                          <Card className="p-4">
                            <Label className="text-muted-foreground">
                              Video Link 2
                            </Label>
                            <a
                              href={submission.rawData.videolink2}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="mt-1 block truncate text-primary hover:underline"
                            >
                              {submission.rawData.videolink2}
                            </a>
                          </Card>
                        )}
                        {submission.rawData?.videolink3 && (
                          <Card className="p-4">
                            <Label className="text-muted-foreground">
                              Video Link 3
                            </Label>
                            <a
                              href={submission.rawData.videolink3}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="mt-1 block truncate text-primary hover:underline"
                            >
                              {submission.rawData.videolink3}
                            </a>
                          </Card>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Section E: Print Media - Scan Copy */}
                {resolvedFiles.printscancopy && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center gap-2">
                        <FileText className="h-5 w-5" />
                        Section E: Publication Details – Print Media
                      </CardTitle>
                      <p className="text-sm text-muted-foreground">
                        Scan Copy of Publication (PDF/Image)
                      </p>
                    </CardHeader>
                    <CardContent>
                      <div className="rounded-lg border p-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FileText className="h-8 w-8 text-primary" />
                            <div>
                              <p className="font-medium">
                                Scan Copy of Publication
                              </p>
                              <p className="text-sm text-muted-foreground">
                                PDF/Image file
                              </p>
                            </div>
                          </div>
                          <a
                            href={resolvedFiles.printscancopy}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary hover:text-primary/80"
                          >
                            <Download className="h-5 w-5" />
                          </a>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}
              </TabsContent>

              <TabsContent value="publications" className="mt-0">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <FileText className="h-5 w-5" />
                      Publication Details
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                      Media coverage and publications
                    </p>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    {/* Section E: Print Media */}
                    {(submission.rawData?.publicationdate ??
                      submission.rawData?.websiteurl ??
                      submission.rawData?.printscancopy) && (
                      <div>
                        <Label className="mb-3 text-base font-semibold">
                          Section E: Print Media
                        </Label>
                        <Card className="p-4">
                          <div className="space-y-3">
                            {submission.rawData?.publicationdate && (
                              <div>
                                <Label className="text-muted-foreground">
                                  Date of Publication
                                </Label>
                                <p className="mt-1">
                                  {formatDate(
                                    submission.rawData.publicationdate
                                  )}
                                </p>
                              </div>
                            )}
                            {submission.rawData?.websiteurl && (
                              <div>
                                <Label className="text-muted-foreground">
                                  Website URL Link
                                </Label>
                                <a
                                  href={submission.rawData.websiteurl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-1 block text-primary hover:underline"
                                >
                                  {submission.rawData.websiteurl}
                                </a>
                              </div>
                            )}
                            {resolvedFiles.printscancopy && (
                              <div className="flex items-center justify-between rounded-lg border p-3">
                                <div className="flex items-center gap-3">
                                  <FileText className="h-6 w-6 text-primary" />
                                  <div>
                                    <p className="font-medium">
                                      Scan Copy of Publication
                                    </p>
                                    <p className="text-sm text-muted-foreground">
                                      PDF/Image file
                                    </p>
                                  </div>
                                </div>
                                <a
                                  href={resolvedFiles.printscancopy}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-primary hover:text-primary/80"
                                >
                                  <Download className="h-5 w-5" />
                                </a>
                              </div>
                            )}
                          </div>
                        </Card>
                      </div>
                    )}

                    {/* Section F: TV Channel */}
                    {(submission.rawData?.tvchannelname ??
                      submission.rawData?.tvtelecastdate ??
                      submission.rawData?.tvprogramurl ??
                      submission.rawData?.tvProgramVideo) && (
                      <div>
                        <Label className="mb-3 text-base font-semibold">
                          Section F: TV Channel
                        </Label>
                        <Card className="p-4">
                          <div className="space-y-3">
                            {submission.rawData?.tvchannelname && (
                              <div>
                                <Label className="text-muted-foreground">
                                  TV Channel Name
                                </Label>
                                <p className="mt-1 font-medium">
                                  {submission.rawData.tvchannelname}
                                </p>
                              </div>
                            )}
                            {submission.rawData?.tvtelecastdate && (
                              <div>
                                <Label className="text-muted-foreground">
                                  Program Telecast Date
                                </Label>
                                <p className="mt-1">
                                  {formatDate(
                                    submission.rawData.tvtelecastdate
                                  )}
                                </p>
                              </div>
                            )}
                            {submission.rawData?.tvprogramurl && (
                              <div>
                                <Label className="text-muted-foreground">
                                  Program URL
                                </Label>
                                <a
                                  href={submission.rawData.tvprogramurl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-1 block text-primary hover:underline"
                                >
                                  {submission.rawData.tvprogramurl}
                                </a>
                              </div>
                            )}
                          </div>
                        </Card>
                      </div>
                    )}

                    {/* Section G: Social Media Links */}
                    {[
                      submission.rawData?.link1,
                      submission.rawData?.link2,
                      submission.rawData?.link3,
                      submission.rawData?.link4,
                    ].some(Boolean) && (
                      <div>
                        <Label className="mb-3 text-base font-semibold">
                          Section G: Social Media Links
                        </Label>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                          {submission.rawData?.link1 && (
                            <Card className="p-4">
                              <Label className="text-muted-foreground">
                                Link 1
                              </Label>
                              <a
                                href={submission.rawData.link1}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1 block truncate text-primary hover:underline"
                              >
                                {submission.rawData.link1}
                              </a>
                            </Card>
                          )}
                          {submission.rawData?.link2 && (
                            <Card className="p-4">
                              <Label className="text-muted-foreground">
                                Link 2
                              </Label>
                              <a
                                href={submission.rawData.link2}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1 block truncate text-primary hover:underline"
                              >
                                {submission.rawData.link2}
                              </a>
                            </Card>
                          )}
                          {submission.rawData?.link3 && (
                            <Card className="p-4">
                              <Label className="text-muted-foreground">
                                Link 3
                              </Label>
                              <a
                                href={submission.rawData.link3}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1 block truncate text-primary hover:underline"
                              >
                                {submission.rawData.link3}
                              </a>
                            </Card>
                          )}
                          {submission.rawData?.link4 && (
                            <Card className="p-4">
                              <Label className="text-muted-foreground">
                                Link 4
                              </Label>
                              <a
                                href={submission.rawData.link4}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1 block truncate text-primary hover:underline"
                              >
                                {submission.rawData.link4}
                              </a>
                            </Card>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Legacy publications fallback */}
                    {submission.publications &&
                      submission.publications.length > 0 && (
                        <div>
                          <Label className="mb-3 text-base font-semibold">
                            Additional Publications
                          </Label>
                          <div className="space-y-3">
                            {submission.publications.map(pub => (
                              <Card
                                key={pub.id}
                                className="p-4 transition-shadow hover:shadow-md"
                              >
                                <div className="flex items-start justify-between">
                                  <div className="flex-1 space-y-1">
                                    <p className="font-medium">
                                      {pub.media_name ?? pub.media_type}
                                    </p>
                                    {pub.publication_date && (
                                      <p className="text-sm text-muted-foreground">
                                        Published:{" "}
                                        {formatDate(pub.publication_date)}
                                      </p>
                                    )}
                                    {pub.url && (
                                      <a
                                        href={pub.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-sm text-primary hover:underline"
                                      >
                                        View Publication
                                      </a>
                                    )}
                                  </div>
                                  {pub.file_url && (
                                    <a
                                      href={pub.file_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-primary hover:text-primary/80"
                                    >
                                      <Download className="h-5 w-5" />
                                    </a>
                                  )}
                                </div>
                              </Card>
                            ))}
                          </div>
                        </div>
                      )}

                    {!submission.rawData?.publicationdate &&
                      !submission.rawData?.websiteurl &&
                      !submission.rawData?.printscancopy &&
                      !submission.rawData?.tvchannelname &&
                      !submission.rawData?.tvtelecastdate &&
                      !submission.rawData?.tvprogramurl &&
                      (!submission.publications ||
                        submission.publications.length === 0) && (
                        <p className="text-center text-muted-foreground">
                          No publications available
                        </p>
                      )}
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="history" className="mt-0">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <History className="h-5 w-5" />
                      Submission History
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="relative space-y-6">
                      {/* Timeline */}
                      <div className="relative">
                        {/* Submission Created */}
                        <div className="relative flex gap-4 pb-6">
                          <div className="flex shrink-0 flex-col items-center">
                            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/20">
                              <FileText className="h-5 w-5 text-blue-600 dark:text-blue-400" />
                            </div>
                            {/* Only show line if there are more items */}
                            {(submission.status === "approved" ||
                              submission.status === "rejected" ||
                              submission.score !== null ||
                              submission.admin_comments !== null) && (
                              <div className="absolute left-1/2 top-10 h-6 w-0.5 -translate-x-1/2 bg-border" />
                            )}
                          </div>
                          <div className="flex-1 pb-6">
                            <p className="font-semibold">Submission Created</p>
                            <p className="text-sm text-muted-foreground">
                              {formatDateTime(submission.created_at)}
                            </p>
                          </div>
                        </div>

                        {/* Approved/Rejected Status */}
                        {(submission.status === "approved" ||
                          submission.status === "rejected") && (
                          <div className="relative flex gap-4 pb-6">
                            <div className="flex shrink-0 flex-col items-center">
                              <div
                                className={`flex h-10 w-10 items-center justify-center rounded-full ${
                                  submission.status === "approved"
                                    ? "bg-green-100 dark:bg-green-900/20"
                                    : "bg-red-100 dark:bg-red-900/20"
                                }`}
                              >
                                {submission.status === "approved" ? (
                                  <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />
                                ) : (
                                  <XCircle className="h-5 w-5 text-red-600 dark:text-red-400" />
                                )}
                              </div>
                              {/* Only show line if there's an evaluated item */}
                              {(submission.score !== null ||
                                submission.admin_comments !== null) && (
                                <div className="absolute left-1/2 top-10 h-6 w-0.5 -translate-x-1/2 bg-border" />
                              )}
                            </div>
                            <div className="flex-1 pb-6">
                              <p className="font-semibold capitalize">
                                {submission.status === "approved"
                                  ? "Approved"
                                  : "Rejected"}
                              </p>
                              <p className="text-sm text-muted-foreground">
                                {submission.reviewed_at
                                  ? formatDateTime(submission.reviewed_at)
                                  : submission.rawData?.reviewed_on
                                    ? formatDateTime(
                                        submission.rawData.reviewed_on
                                      )
                                    : submission.rawData?.updated_on
                                      ? formatDateTime(
                                          submission.rawData.updated_on
                                        )
                                      : submission.rawData?.updated_at
                                        ? formatDateTime(
                                            submission.rawData.updated_at
                                          )
                                        : formatDateTime(submission.created_at)}
                              </p>
                            </div>
                          </div>
                        )}

                        {/* Evaluated - Show when score or comments exist */}
                        {(submission.score !== null ||
                          submission.admin_comments !== null) && (
                          <div className="relative flex gap-4">
                            <div className="flex shrink-0 flex-col items-center">
                              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/20">
                                <Trophy className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                              </div>
                              {/* No line after the last item */}
                            </div>
                            <div className="flex-1">
                              <p className="font-semibold">Evaluated</p>
                              <p className="text-sm text-muted-foreground">
                                {submission.reviewed_at
                                  ? formatDateTime(submission.reviewed_at)
                                  : submission.rawData?.reviewed_on
                                    ? formatDateTime(
                                        submission.rawData.reviewed_on
                                      )
                                    : submission.rawData?.updated_on
                                      ? formatDateTime(
                                          submission.rawData.updated_on
                                        )
                                      : submission.rawData?.updated_at
                                        ? formatDateTime(
                                            submission.rawData.updated_at
                                          )
                                        : formatDateTime(submission.created_at)}
                              </p>
                              {submission.admin_comments && (
                                <p className="mt-2 text-sm italic text-muted-foreground">
                                  &quot;{submission.admin_comments}&quot;
                                </p>
                              )}
                              {submission.score && (
                                <p className="mt-2 text-lg font-bold text-primary">
                                  Score: {submission.score}/100
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>
            </div>

            {/* Review Sidebar */}
            <div className="lg:col-span-1">
              {submission.status === "approved" ? (
                // Evaluation Box for Approved Submissions
                <Card className="sticky top-6">
                  <CardHeader className="bg-gradient-to-br from-primary/5 to-primary/10">
                    <CardTitle className="flex items-center gap-2">
                      <Trophy className="h-5 w-5 text-primary" />
                      Review & Scoring
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                      Evaluate this submission
                    </p>
                  </CardHeader>
                  <CardContent className="space-y-6 pt-6">
                    {/* Score Input */}
                    <div>
                      <Label
                        htmlFor="score"
                        className="text-base font-semibold"
                      >
                        Score (1-100) <span className="text-red-500">*</span>
                      </Label>
                      <div className="relative mt-2">
                        <Input
                          id="score"
                          type="number"
                          min="0"
                          max="100"
                          value={score ?? ""}
                          onChange={e => {
                            const inputValue = e.target.value;
                            if (inputValue === "") {
                              setScore(null);
                              return;
                            }
                            const numValue = Number(inputValue);
                            if (!isNaN(numValue)) {
                              if (numValue > 100) {
                                setScore(100);
                              } else if (numValue < 0) {
                                setScore(0);
                              } else {
                                setScore(numValue);
                              }
                            }
                          }}
                          placeholder=""
                          className="pr-16 text-2xl font-bold"
                        />
                        <div className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
                          / 100
                        </div>
                      </div>
                      {score !== null && score > 0 && (
                        <Progress value={score} className="mt-3 h-2" />
                      )}
                      <div className="mt-3 flex flex-wrap gap-2">
                        {[60, 70, 80, 90, 95, 100].map(val => (
                          <Button
                            key={val}
                            size="sm"
                            variant={score === val ? "default" : "outline"}
                            onClick={() => setScore(val)}
                            className="h-8"
                          >
                            {val}
                          </Button>
                        ))}
                      </div>
                    </div>

                    {/* Review Comments */}
                    <div>
                      <Label
                        htmlFor="comments"
                        className="text-base font-semibold"
                      >
                        Review Comments <span className="text-red-500">*</span>
                      </Label>
                      <Textarea
                        id="comments"
                        value={comments}
                        onChange={e => setComments(e.target.value)}
                        placeholder="Excellent submission with great documentation"
                        rows={4}
                        className="mt-2"
                      />
                      <div className="mt-2 flex flex-wrap gap-2">
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => setComments("Excellent work!")}
                          className="h-8 text-xs"
                        >
                          + Excellent work!
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => setComments("Good effort.")}
                          className="h-8 text-xs"
                        >
                          + Good effort.
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => setComments("Needs improvement.")}
                          className="h-8 text-xs"
                        >
                          + Needs improvement.
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() =>
                            setComments("Please add more details.")
                          }
                          className="h-8 text-xs"
                        >
                          + Please add more details.
                        </Button>
                      </div>
                    </div>

                    {/* Save Button */}
                    <div className="border-t pt-4">
                      <Button
                        onClick={handleUpdateEvaluation}
                        disabled={actionLoading}
                        className="w-full bg-primary text-white hover:bg-primary/90"
                        size="lg"
                      >
                        {actionLoading ? (
                          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        ) : (
                          <FileText className="mr-2 h-4 w-4" />
                        )}
                        Save Evaluation
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ) : submission.status === "pending" ? (
                // Approve/Reject Buttons for Pending Submissions
                <Card className="sticky top-6">
                  <CardHeader className="bg-gradient-to-br from-primary/5 to-primary/10">
                    <CardTitle className="flex items-center gap-2">
                      <Trophy className="h-5 w-5 text-primary" />
                      Review & Scoring
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                      Evaluate this submission
                    </p>
                  </CardHeader>
                  <CardContent className="space-y-2 pt-6">
                    <Button
                      onClick={handleApprove}
                      disabled={actionLoading}
                      className="w-full bg-blue-600 text-white hover:bg-blue-700"
                      size="lg"
                    >
                      {actionLoading ? (
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      ) : (
                        <FileText className="mr-2 h-4 w-4" />
                      )}
                      Approve Submission
                    </Button>

                    <Button
                      onClick={() => setShowRejectDialog(true)}
                      disabled={actionLoading}
                      variant="destructive"
                      size="lg"
                      className="w-full"
                    >
                      <FileText className="mr-2 h-4 w-4" />
                      Reject Submission
                    </Button>
                  </CardContent>
                </Card>
              ) : (
                // Previous Review for Rejected/Other Statuses
                <Card className="sticky top-6">
                  <CardHeader>
                    <CardTitle>Previous Review</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    {submission.status !== "rejected" &&
                      submission.admin_comments && (
                        <div>
                          <p className="text-sm text-muted-foreground">
                            &quot;{submission.admin_comments}&quot;
                          </p>
                        </div>
                      )}
                    {submission.status !== "rejected" && submission.score && (
                      <div>
                        <Label className="text-muted-foreground">Score</Label>
                        <p className="mt-1 text-2xl font-bold text-green-600">
                          {submission.score}/100
                        </p>
                      </div>
                    )}
                    {submission.status === "rejected" && (
                      <p className="text-sm text-muted-foreground">
                        This submission has been rejected.
                      </p>
                    )}
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </Tabs>
      </div>

      {/* Reject Dialog */}
      <AlertDialog open={showRejectDialog} onOpenChange={setShowRejectDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Reject Submission</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to reject this submission? This action
              cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={actionLoading}>
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleReject}
              disabled={actionLoading}
              className="bg-red-600 hover:bg-red-700"
            >
              {actionLoading && (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              )}
              Confirm Rejection
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </AdminLayout>
  );
};

export default AdminSubmissionReview;
